import EstadoDeudaForm from './EstadoDeudaForm'
export {EstadoDeudaForm}
export default EstadoDeudaForm
